<div style="display: flex; flex-direction: column; align-items: center;">
    <h1>ESTAMOS TRABAJANDO PARA PRESTAR UN MEJOR SERVICIO</h1>
    <img src='assets/icons/OFV/procedimientos.svg' style="width: 10%;" alt="img">
</div>
